export default "__VITE_ASSET__amwAY4dB__"